<template>
  <div class="modal-mask" v-show="showFieldWatchModal" transition="modal">
    <div class="modal-wrapper">
      <div class="modal-container">
        <div class="modal-header">
          <slot name="header">Свойства</slot>
          <br />
          <slot v-if="field.state" class="font-weight-bold"
            >актульное состояние {{ field.state }}</slot
          >
        </div>
        <div class="modal-body">
          <div class="d-flex justify-content-between">
            <div>Класс:</div>
            <div>{{ selectedProduct.code }} -- {{ selectedProduct.title }}</div>
          </div>

          <b-tabs
            v-if="field.translations && field.translations.length > 0"
            content-class="mt-3"
            fill
            style="margin: 20px 0; overflow-x: hidden; max-height: 500px"
          >
            <b-tab
              v-for="translation in field.translations"
              :title="translation.locale"
              active
              :key="translation.id"
            >
              <div class="form-group">
                <label>Наименование свойства</label>
                <input
                  type="text"
                  class="form-control"
                  :value="translation.title"
                  disabled
                />
              </div>
              <div class="form-group">
                <label>Описание свойства</label>
                <input
                  type="text"
                  class="form-control"
                  :value="translation.comment"
                  disabled
                />
              </div>
            </b-tab>

            <b-tab v-if="field.language" :title="field.language" active>
              <div class="form-group">
                <label
                  >Наименование свойства
                  <span class="btn btn-danger m-0 p-0">новое</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  :value="field[field.language + '_title']"
                  disabled
                />
              </div>
              <div class="form-group">
                <label>
                  Описание свойства
                  <span class="btn btn-danger m-0 p-0">новое</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  :value="field[field.language + '_comment']"
                  disabled
                />
              </div>
            </b-tab>
          </b-tabs>
          <div v-else>
            <div class="form-group">
              <label>Наименование свойства</label>
              <input
                type="text"
                class="form-control"
                v-model="field.ru_title"
                disabled
              />
            </div>
            <div class="form-group">
              <label>Описание свойства</label>
              <input
                type="text"
                class="form-control"
                v-model="field.ru_comment"
                disabled
              />
            </div>
          </div>
          <div class="form-group">
            <label>Обязательное свойство?</label>
            <select :value="field.isRequired" class="form-control" disabled>
              <option value="1">Да</option>
              <option value="0">Нет</option>
            </select>
          </div>
          <div class="form-group">
            <label
              >Тип свойства (RADIO | CHECKBOX | TEXT | NUMBER |
              MULTISELECT)</label
            >
            <select class="form-control" v-model="field.inputType" disabled>
              <template v-for="fieldType in fieldTypes">
                <option
                  :value="fieldType.value"
                  v-if="field.inputType === fieldType.value"
                  :key="fieldType.id"
                >
                  {{ fieldType.title }}
                </option>
              </template>
            </select>
          </div>
          <div id="CheckBoxBlock">
            <div class="w-100 d-flex justify-content-sm-between">
              <h2 v-if="field.inputType === 'checkbox'">CHECKBOX</h2>
              <h2 v-else-if="field.inputType === 'radio'">Radio</h2>
              <h2 v-else-if="field.inputType === 'multiselect'">MULTISELECT</h2>
              <h2 v-else-if="field.inputType === 'range'">RANGE</h2>
            </div>

            <div v-for="(row, index) in fieldValues" :key="index" :row="row">
              <div class="row">
                <div
                  v-if="field.inputType === 'range'"
                  class="col-md-12 d-flex"
                >
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>От</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="row.value.from"
                        spellcheck="true"
                        disabled
                      />
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>До</label>
                      <div class="d-flex">
                        <input
                          type="text"
                          class="form-control"
                          :class="{
                            'bg-danger': row.state && row.state !== 'A',
                          }"
                          v-model="row.value.to"
                          spellcheck="true"
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else class="col-md-12 d-flex">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label>Значение</label>
                      <div class="d-flex">
                        <input
                          type="text"
                          class="form-control"
                          :class="{
                            'bg-danger': row.state && row.state !== 'A',
                          }"
                          v-model="row.value"
                          spellcheck="true"
                          disabled
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="alert alert-danger" v-if="comment">
            <b>Комментарий:</b> {{ comment }}
          </div>
        </div>

        <div class="modal-footer">
          <slot name="footer">
            <button
              class="modal-button btn btn-danger"
              @click="updateTab('update', { modal: 'field', visible: false })"
            >
              Закрыть
            </button>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    selectedProduct: {
      code: null,
      title: null,
    },
    showFieldWatchModal: false,
    units: [],
    field: {},
    fieldValues: [],
    comment: null,
  },
  data() {
    return {
      checkboxRows: [{ value: "" }],
      checkboxRowsForLanguage: [],
      rangeRows: [{ from: "", to: "" }],
      fieldTypes: [
        {
          id: 1,
          value: "range",
          title: "Диапазон",
        },
        {
          id: 2,
          value: "checkbox",
          title: "Несколько из нескольких (checkbox)",
        },
        {
          id: 3,
          value: "boolean",
          title: "Да Нет (Boolean)",
        },
        {
          id: 4,
          value: "radio",
          title: "Один из нескольких (radio)",
        },
        {
          id: 5,
          value: "text",
          title: "Текстовое поле (text)",
        },
        {
          id: 6,
          value: "number",
          title: "Числовое поле (number)",
        },
        {
          id: 7,
          value: "multiselect",
          title: "один из многих",
        },
      ],
    };
  },
  methods: {
    updateTab(event = "update", spec) {
      this.$emit(event, spec);
      // console.log(this.specification.fields);
    },
  },
  mounted() {
    console.log("field", this.field);
    console.log("fieldValues", this.fieldValues);
  },
};
</script>

<style scoped></style>
